/* eslint-disable @typescript-eslint/no-require-imports */
import type { AppleIntelligenceService } from "$src/core/services/search-classification/types";
import CustomPlatform from "$src/core/utils/platform/platform";

const unavailable: AppleIntelligenceService = {
  status: "unavailable",
  prepare: async () => {},
  classify: async () => null,
};

export default CustomPlatform.select<() => AppleIntelligenceService>({
  ios: () => require("./apple-intelligence.ios").default,
  default: () => unavailable,
})();
